import ButtonShowModalMineralCountries from './ButtonShowModalMineralCountries'
import ButtonMineralsOptions from './ButtonMineralsOptions'

export default function MineralsGridItem({ mineral }) {
  return (
    <div className="col-span-12 flex flex-col md:col-span-6 lg:col-span-4 xl:col-span-3">
      <div
        className={`relative flex flex-col border-2 ${mineral.status === 'PUBLISHED' ? 'bg-white' : 'bg-muted-300'} border-muted-500`}
      >
        <img
          alt={mineral?.name_ar}
          src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral?.image}`}
          className="absolute left-0 top-0 h-14 w-14 transform rounded-full p-1"
        />
        <div className="p-2">
          <h2 className="text-sm font-bold">
            {mineral?.name_ar}{' '}
            {mineral.symbol && (
              <span className="text-accent-600">({mineral?.symbol})</span>
            )}
          </h2>
          <h2 className="text-sm font-bold">{mineral?.name_en}</h2>
        </div>
        <div className="flex justify-between gap-2 border-t-2 border-muted-500 p-2">
          <ButtonShowModalMineralCountries mineralId={mineral.id} />
          <ButtonMineralsOptions mineral={mineral} />
        </div>
      </div>
    </div>
  )
}
